import {
    GetEnableBulkCompletePhaseAction,
    GetProjectDetailsAction,
    GetWorkflowDefinitionsAction,
    SetEnableBulkCompletePhaseAction,
    SetProjectDetailsAction,
    SetWorkflowDefinitionsAction,
} from "../../interfaces/store/actions/project";
import {
    GET_ENABLE_BULK_COMPLETE,
    GET_PROJECT_DETAILS,
    GET_WORKFLOW_DEFINITIONS,
    SET_ENABLE_BULK_COMPLETE,
    SET_PROJECT_DETAILS,
    SET_WORKFLOW_DEFINITIONS,
} from "./availableActions";
import {ProjectDetails} from "../../interfaces/store/actions/payload/project";
import {WorkflowDefinition} from "../../interfaces/store/actions/payload/workflowDefinitions";

export const getProjectDetails = (payload: string): GetProjectDetailsAction => ({
    type: GET_PROJECT_DETAILS,
    payload,
});

export const setProjectDetails = (payload: ProjectDetails): SetProjectDetailsAction => ({
    type: SET_PROJECT_DETAILS,
    payload,
});

export const getWorkflowDefinitions = (payload: string): GetWorkflowDefinitionsAction => ({
    type: GET_WORKFLOW_DEFINITIONS,
    payload,
});

export const setWorkflowDefinitions = (payload: WorkflowDefinition[]): SetWorkflowDefinitionsAction => ({
    type: SET_WORKFLOW_DEFINITIONS,
    payload,
});

export const getEnableBulkCompletePhaseAction = (): GetEnableBulkCompletePhaseAction => ({
    type: GET_ENABLE_BULK_COMPLETE,
});

export const setEnableBulkCompletePhaseAction = (payload: boolean): SetEnableBulkCompletePhaseAction => ({
    type: SET_ENABLE_BULK_COMPLETE,
    payload,
});
